import Markdown from "reveal.js/plugin/markdown/markdown.esm.js";
import { querySelectorURL } from "../../cpcoc/querySelectorURL";
export const slideOptions = {
    margin: Number(querySelectorURL("margin")) || 0.02,
    center: false,
    hash: false,
    respondToHashChanges: false,
    history: false,
    transition: querySelectorURL("transition") || "fade",
    loop: querySelectorURL("autoPlayMedia") || true,
    preloadIframes: querySelectorURL("preloadIframes") || true,
    autoPlayMedia: querySelectorURL("autoPlayMedia") || true,
    controls: querySelectorURL("controls") || false,
    progress: querySelectorURL("progress") || false,
    pause: false,
    autoSlide: querySelectorURL("autoslide") === "false" ? false : 15000,
    autoSlideStoppable: querySelectorURL("autoSlideStoppable") || false,
    plugins: [Markdown],
};
